import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(sessionStorage.getItem('access_token'));
    const [refreshToken, setRefreshToken] = useState(sessionStorage.getItem('refresh_token'));

    useEffect(() => {
        if (authToken) {
            sessionStorage.setItem('access_token', authToken);
        } else {
            sessionStorage.removeItem('access_token');
        }
    }, [authToken]);

    useEffect(() => {
        if (refreshToken) {
            sessionStorage.setItem('refresh_token', refreshToken);
        } else {
            sessionStorage.removeItem('refresh_token');
        }
    }, [refreshToken]);

    const login = (token, refresh) => {
        setAuthToken(token);
        setRefreshToken(refresh);
    };

    const logout = () => {
        setAuthToken(null);
        setRefreshToken(null);
    };

    return (
        <AuthContext.Provider value={{ authToken, refreshToken, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
